import { Injectable } from '@angular/core';
import { MatDrawerMode } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import {
  LayoutClassesEnum,
  LayoutClassesEnumNames,
} from '../models/layout-classes.enum';
import { HubspotService } from './hubspot.service';
import { LocalStorageService } from './local-storage.service';

const isOpenedStoreKey = 'is_opened_left_menu';

@Injectable({
  providedIn: 'root',
})
export class NavbarService {
  public readonly version = 'Agents - 0.0.1';

  public readonly openTransferMoney$ = new ReplaySubject<void>(1);
  public readonly rewardClaimed$ = new ReplaySubject<void>(1);
  public closeTransferMoney = new Subject<void>();

  public activeLink = new BehaviorSubject('');
  public isOpenedMenu = this.localStorageService.getBoolean(isOpenedStoreKey);
  public modeMenu: MatDrawerMode = 'side';
  public isDesktop = true;
  // By default we apply Desktop layout. Changes comes from app.component
  public layoutClass: string =
    LayoutClassesEnumNames[LayoutClassesEnum.Desktop];
  private chatHTMLElement: HTMLElement;

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private hubspotService: HubspotService,
  ) {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        this.activeLink.next(this.router.url.split(/[?#]/)[0]);

        if (this.isDesktop) {
          this.openMenu();
        }
      });
  }

  public setLayout(layout: LayoutClassesEnum) {
    this.isDesktop = layout === LayoutClassesEnum.Desktop;
    this.modeMenu =
      layout === LayoutClassesEnum.Desktop
        ? 'side'
        : layout === LayoutClassesEnum.Tablet
          ? 'push'
          : 'over';
    this.layoutClass = LayoutClassesEnumNames[layout];
    if (!this.isDesktop) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  public openMenu(): void {
    this.isOpenedMenu = true;

    if (this.chatHTMLElement) {
      this.chatHTMLElement.classList.add('hide-chat');
      return;
    }

    this.hubspotService.getChatElement().then((q) => {
      this.chatHTMLElement = q;
      try {
        this.chatHTMLElement.classList.add('hide-chat');
      } catch (e) {
        return;
      }
    });
  }

  public closeMenu(): void {
    this.isOpenedMenu = false;
    if (this.chatHTMLElement) {
      this.chatHTMLElement.classList.remove('hide-chat');
    }
  }

  public toggleMenu(): void {
    this.isOpenedMenu = !this.isOpenedMenu;
  }

  public closeMenuIfMobile(): void {
    if (!this.isDesktop) {
      this.closeMenu();
    }
  }

  public async goBack() {
    if (window.history.length > 0) {
      window.history.back();
    } else {
      await this.router.navigate(['../']);
    }
  }

  public clearOpenTransferMoney(): void {
    (this as any).openTransferMoney$ = new ReplaySubject<void>(1);
  }

  public onRewardClaimed(): Observable<void> {
    return this.rewardClaimed$.asObservable();
  }

  public emitRewardClaimed(): void {
    this.rewardClaimed$.next();
  }
}
